import type { Color, CommonColors } from '@mui/material/styles'

interface XwiPaletteType {
	common: CommonColors
	thunder: Color
	teal: Color
	blue: Color
	green: Color
	yellow: Color
	orange: Color
	red: Color
	violet: Color
	grey: Color
	greyDark: Color & { 75: string }
}

/**
 * @private Use theme tokens instead of directly importing the palette.
 */
export const xwiPalette: XwiPaletteType = {
	common: {
		black: '#000000',
		white: '#ffffff',
	},
	thunder: {
		50: '#EFF6F8',
		100: '#C7E0F0',
		200: '#A6CFE8',
		300: '#72B7DE',
		400: '#48A1D6',
		500: '#2D8EC8',
		600: '#2972A3',
		700: '#205279',
		800: '#113A55',
		900: '#0A2A3D',
		A100: '#C7E0F0',
		A200: '#A6CFE8',
		A400: '#48A1D6',
		A700: '#205279',
	},
	teal: {
		50: '#f8fdff',
		100: '#e6f8ff',
		200: '#c5f0fe',
		300: '#96e3fd',
		400: '#5fd3f9',
		500: '#2bc3f4',
		600: '#02b1e7',
		700: '#009ac8',
		800: '#006e93',
		900: '#004966',
		A100: '#e6f8ff',
		A200: '#c5f0fe',
		A400: '#5fd3f9',
		A700: '#009ac8',
	},
	blue: {
		50: '#f8fbfe',
		100: '#e6f1fd',
		200: '#c7e0fb',
		300: '#9bc6f8',
		400: '#68a5f3',
		500: '#3884eb',
		600: '#1265da',
		700: '#0049b3',
		800: '#003076',
		900: '#001b42',
		A100: '#e6f1fd',
		A200: '#c7e0fb',
		A400: '#68a5f3',
		A700: '#0049b3',
	},
	green: {
		50: '#f5fbf6',
		100: '#e1f4e4',
		200: '#c0ebc9',
		300: '#96dda7',
		400: '#67cb82',
		500: '#3db360',
		600: '#1f9544',
		700: '#0d742e',
		800: '#05531f',
		900: '#023312',
		A100: '#e1f4e4',
		A200: '#c0ebc9',
		A400: '#67cb82',
		A700: '#0d742e',
	},
	yellow: {
		50: '#fffcf1',
		100: '#fffcd8',
		200: '#fff8c3',
		300: '#fff09f',
		400: '#ffe071',
		500: '#fdd02f',
		600: '#efbb00',
		700: '#bf8a02',
		800: '#856000',
		900: '#4e3903',
		A100: '#fffcd8',
		A200: '#fff8c3',
		A400: '#ffe071',
		A700: '#bf8a02',
	},
	orange: {
		50: '#fefbf8',
		100: '#fdf1e6',
		200: '#fbe1c8',
		300: '#f8cb9e',
		400: '#f4b16c',
		500: '#ec973d',
		600: '#dc7f18',
		700: '#b76101',
		800: '#7e4300',
		900: '#4d2900',
		A100: '#fdf1e6',
		A200: '#fbe1c8',
		A400: '#f4b16c',
		A700: '#b76101',
	},
	red: {
		50: '#fef9f8',
		100: '#fde9e7',
		200: '#fbd1ca',
		300: '#f8b0a2',
		400: '#f38b72',
		500: '#eb6844',
		600: '#da4b20',
		700: '#b23109',
		800: '#741d00',
		900: '#401000',
		A100: '#fde9e7',
		A200: '#fbd1ca',
		A400: '#f38b72',
		A700: '#b23109',
	},
	violet: {
		50: '#fafcfe',
		100: '#edf2fd',
		200: '#d7ddfc',
		300: '#b9bbf9',
		400: '#9994f5',
		500: '#8070ee',
		600: '#6b52e0',
		700: '#5538bf',
		800: '#3c238d',
		900: '#291661',
		A100: '#edf2fd',
		A200: '#d7ddfc',
		A400: '#9994f5',
		A700: '#5538bf',
	},
	grey: {
		50: '#f9fafa',
		100: '#eef1f3',
		200: '#dee3e8',
		300: '#c9d0d9',
		400: '#aeb7c4',
		500: '#909aa9',
		600: '#6B7788',
		700: '#4f5763',
		800: '#30353d',
		900: '#141619',
		A100: '#eef1f3',
		A200: '#dee3e8',
		A400: '#aeb7c4',
		A700: '#4f5763',
	},
	greyDark: {
		50: '#141619',
		75: '#1c2025',
		100: '#30353d',
		200: '#4f5763',
		300: '#6B7788',
		400: '#909aa9',
		500: '#aeb7c4',
		600: '#c9d0d9',
		700: '#dee3e8',
		800: '#eef1f3',
		900: '#f9fafa',
		A100: '#1c2025',
		A200: '#4f5763',
		A400: '#909aa9',
		A700: '#dee3e8',
	},
}
